import { appRouters } from '../../router/router'
import Util from '../../lib/util';
import Vue from 'vue';
import { Store, Module, ActionContext } from 'vuex'
import Vuex from 'vuex';
import ajax from '../../lib/ajax'
import appconst from '../../lib/appconst'
// import qs from 'qs'
import App from "@/app.vue";
import ajaxHelperInstance from "@/lib/ajaxhelper";
Vue.use(Vuex);
interface AppState {
    cachedComp:Array<string>,
    infoWin:any,
}
class AppModule implements Module<AppState, any>{
    namespaced = true;
    state = {
        cachedComp:[],
        infoWin:null
    };
    mutations = {
        logout(state: AppState) {
            Util.abp.auth.setToken('');
            localStorage.clear();
            sessionStorage.clear();
        },
        /**
         * 设置缓存的组件列表
         * @param state
         * @param cachedList 新组件
         */
        setCachedComp(state:AppState,cachedList){
            state.cachedComp = cachedList;
        },
        /***
         * 增加缓存列表
         * @param state
         * @param compName
         */
        addKeepAliveComp(state:AppState,compName){
          if(!_.find(state.cachedComp,(o)=>{return o==compName})){
              state.cachedComp.push(compName);
          }
        },
        /**
         * 删除保持存在的组件
         * @param state
         * @param compName
         */
        removeKeepAliveComp(state:AppState,compName){
            let c= state.cachedComp
            _.remove(c,(o)=>{return o==compName});
            state.cachedComp = [...c];
        }
    }
    actions = {
        async login(content: ActionContext<AppState, any>, payload: any) {
            let authURL = appconst.authConfig.authUrl;
            let vueInstance = payload.data.vueInstance;
            let postData = {
                username:payload.data.username,
                password:payload.data.password,
                mobile:payload.data.mobile,
                code:payload.data.code
            }
            let reqType = payload.data.loginType;

            let reqUrl = '/web/auth/login';

            if(reqType === '0'){
                postData.mobile = postData.username;
            }else{
                reqUrl = '/web/auth/loginByCode';
            }

            if(content.state.infoWin){
                content.state.infoWin();
                content.state.infoWin = null;
            }

            let rep = await ajaxHelperInstance.postM(reqUrl, postData);
            var tokenExpireDate = undefined;
            // var tokenExpireDate = payload.data.rememberMe ? (new Date(new Date().getTime() + 1000 * rep.data.expires_in)) : undefined;
            if(rep.data.errno!=0){
                content.state.infoWin = vueInstance.$message.info(rep.data.message);
                return 0;
            }else{
                Util.abp.auth.setToken(rep.data.data.access_token, tokenExpireDate);
            }

            // Util.abp.utils.setCookieValue(appconst.authorization.encrptedAuthTokenName, rep.data.accessToken, tokenExpireDate, Util.abp.appPath)
        },
    }
}
const appModule = new AppModule();
export default appModule;
